import React, { useEffect, useMemo, useState } from 'react';
import T from 'i18n';
import { useSelector } from 'react-redux';
import { Col, Form, Row } from 'react-bootstrap';
import { Modal } from 'features/common/MaterialBasedComponents';
import { selectDocuments } from 'common/selectors';
import { getNextDuplicateName } from '../../redux/duplicateFile';

const ModalDuplicate = ({ show, handleClose, handleSave, action, selectedRows }) => {
  const documents = useSelector(selectDocuments);
  const selectedDocument = selectedRows?.[0] || null;
  const [loading, setLoading] = useState(false);
  const [duplicateName, setDuplicateName] = useState('');
  const suggestedName = useMemo(
    () =>
      getNextDuplicateName({
        documents,
        sourceDocument: selectedDocument,
        fallbackName: selectedDocument?.name || selectedDocument?.originalName || '',
      }),
    [documents, selectedDocument],
  );
  const hasName = !!String(duplicateName || '').trim();

  useEffect(() => {
    if (!show) {
      setLoading(false);
      return;
    }
    setLoading(false);
    setDuplicateName(suggestedName);
  }, [show, suggestedName]);

  return (
    <Modal
      show={show}
      title={T.translate('generic.duplicate')}
      handleClose={handleClose}
      handleSave={() => {
        if (!hasName || loading) {
          return;
        }
        setLoading(true);
        handleSave(
          null,
          action,
          selectedRows,
          { name: String(duplicateName || '').trim() },
          handleClose,
          setLoading,
        );
      }}
      saveTitle={T.translate('generic.duplicate')}
      disableSave={loading || !hasName}
    >
      <Form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Form.Group>
          <Row>
            <Col>
              <Form.Label htmlFor="duplicate-file-name-input">
                {T.translate('case.duplicateFileNameLabel')}
              </Form.Label>
              <Form.Control
                id="duplicate-file-name-input"
                type="text"
                placeholder={T.translate('case.duplicateFileNamePlaceholder')}
                value={duplicateName}
                onChange={(event) => setDuplicateName(event.target.value)}
                autoFocus={show}
              />
            </Col>
          </Row>
        </Form.Group>
      </Form>
    </Modal>
  );
};

export default ModalDuplicate;
